import React, { useState, useEffect } from 'react';
import './HeaderInsideFooter.css';
import logomenuinsidefooter from '../images/logo.png';
import { Link } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const HeaderInsideFooter = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${apiUrl}/user`, { credentials: 'include' });
        const user = await res.json();
        setUserData(user);
      } catch (err) {
        setUserData(null);
      }
    };
    fetchUser();
  }, []);
  return (
    <header className='header-inside-footer'>
      <div className='header-inside-container'>
        <Link to='/functionalpagelogin' className='header-inside-brand'>
          <img src={logomenuinsidefooter} alt='ContaLearn logo' className='header-inside-logo' />
         
        </Link>

        <nav className='header-inside-nav'>
          <Link to='/functionalpagelogin' className='header-inside-nav-link'>Invata</Link>
          <Link to='/blog' className='header-inside-nav-link'>Blog</Link>
          <Link to='/about' className='header-inside-nav-link'>Despre</Link>
          <Link to='/ajutor' className='header-inside-nav-link'>Contact</Link>
         
        </nav>

        <Link to='/functionalpagelogin' className='header-user-avatar'>
          {userData?.profile_picture ? (
            <img src={userData.profile_picture} alt='User' className='header-avatar-img' />
          ) : (
            <div className='header-avatar-placeholder'>👤</div>
          )}
        </Link>
      </div>
    </header>
  );
};

export default HeaderInsideFooter;
